import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { AdAccountProvider } from "./lib/adAccount";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Chat from "./pages/Chat";
import Dashboard from "./pages/Dashboard";
import Campaigns from "./pages/Campaigns";
import Creatives from "./pages/Creatives";
import Audience from "./pages/Audience";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import AuditLog from "./pages/AuditLog";
import Privacy from "./pages/Privacy";

function ProtectedRoute({ children, adminOnly }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AdAccountProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<Chat />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/campaigns" element={<Campaigns />} />
                  <Route path="/creatives" element={<Creatives />} />
                  <Route path="/audience" element={<Audience />} />
                  <Route path="/audit" element={<AuditLog />} />
                  <Route path="/settings" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
                  <Route path="/users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </AdAccountProvider>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
